﻿class archdatadiff_aupcompare_ti extends Tango.Component {
	widgetDidMount() {
		var _this = this;

		document.querySelectorAll("a[data-openDialogTI]").forEach(function (a) {
			var arg = a.getAttribute('data-openDialogTI');
			a.addEventListener("click", function () {
				_this.openDialogTI(arg = '' ? null : arg);
			});
		});
		document.querySelectorAll("a[data-clearti]").forEach(function (a) {
			var arg = a.getAttribute('data-clearti');
			a.addEventListener("click", function () {
				_this.clearTI(arg = '' ? null : arg);
			});
		});
	}

	onResult(state) {
		if (state == 0) {
			const sd = document.getElementById(this.props.selectDialogID);
			dialog.close(sd);
			return false;
		}
	}

	openDialogTI(field) {
		if (field == null && document.querySelectorAll("table[data-table-tidata] tr[class*='checked']").length == 0) {
			alert('Не выбраны получасовки для установки причины');
			return;
		}
		const sd = document.getElementById(this.props.selectDialogID);
		if (sd === null)
			return false;;
		dialog.open(sd);

		if (window.innerWidth > 800)
			sd.style.width = window.innerWidth - 500 + 'px';
		else
			sd.style.width = 500 + 'px';


		//if (document.getElementById("sectionaupcompare_result_right_tabs_tabdata_ti_data").offsetWidth < (window.innerWidth - sd.offsetWidth)) {
		//	sd.style.left = (document.getElementById("sectionaupcompare_result_right_tabs_tabdata_ti_data").offsetWidth + 10).toString() + 'px';
		//	sd.style.marginLeft = "0px";
		//}
		sd.querySelectorAll("tr[data-reasonid] a").forEach(function (a) {
			a.onclick = function () {
				const isCollapsed = this.firstChild.classList.contains('icon-collapsed');
				if (isCollapsed) {
					this.childNodes[0].classList.remove('icon-collapsed');
					this.childNodes[0].classList.add('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.remove('hide');
					});
				}
				else {
					this.childNodes[0].classList.add('icon-collapsed');
					this.childNodes[0].classList.remove('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.add('hide');
					});
				}
			}
		});
		var _this = this;
		sd.querySelectorAll(".archdatareasoncaseicon").forEach(function (div) {
			const td = div.parentElement;
			const tr = td.parentElement;
			td.onclick = function () {
				var caseid = tr.getAttribute("data-caseid");
				var reasonid = tr.getAttribute("data-reasonid");
				var casename = tr.getAttribute("data-case");
				var reasonname = tr.getAttribute("data-reason");
				var caseNumber = div.innerHTML;
				var reasonNumber = div.getAttribute("data-reasonnumber");

				var names = [];
				if (field == null) {
					document.querySelectorAll("tr[class*='checked'][data-withreason]").forEach(function (el) {
						var container = el.querySelector("div[data-id*='_r']");
						if (container != null) {
							var name = container.getAttribute("data-id").replace("_r", "");
							names.push(name);
						}
					});
				}
				else {
					names.push(field);
				}
				names.forEach(function (name) {
					if (!_this.state.diffjson[name])
						_this.state.diffjson[name] = {};
					_this.state.diffjson[name].archDataDiffReason_ID = reasonid;
					_this.state.diffjson[name].archDataDiffReasonNumber = reasonNumber;
					_this.state.diffjson[name].archDataDiffReasonCase_ID = caseid;
					_this.state.diffjson[name].archDataDiffReasonCaseNumber = caseNumber;
					if (_this.state.diffjson[name].archDataDiff_ID < 0)
						_this.state.diffjson[name].archDataDiff_ID = _this.state.diffjson[name].archDataDiff_ID * (-1);

					var col_r = document.querySelector("div[data-id='" + name + "_r']");
					//col_r.classList.replace("archdatareasoncol_" + col_r.innerHTML, "archdatareasoncol_" + _this.state.diffjson[name].archDataDiffReasonNumber);
					col_r.classList.remove("archdatareasoncol_" + col_r.innerHTML);
					col_r.classList.add("archdatareasoncol_" + _this.state.diffjson[name].archDataDiffReasonNumber);

					col_r.innerHTML = _this.state.diffjson[name].archDataDiffReasonNumber;
					col_r.classList.remove("hide");
					col_r.setAttribute("title", reasonname);
					var col_c = document.querySelector("div[data-id='" + name + "']");
					col_c.innerHTML = _this.state.diffjson[name].archDataDiffReasonCaseNumber;
					col_c.classList.remove("hide");
					col_c.setAttribute("title", casename);
					//var del = document.querySelector("a[data-clearti='" + name + "']");
					//del.classList.remove("hide");
					document.querySelector("input[name='diffjsonti']").value = encodeURIComponent(JSON.stringify(_this.state.diffjson));
					col_r.parentNode.removeAttribute("style");
					col_c.parentNode.removeAttribute("style");

				});
				dialog.close(sd);
			};
		});

		return false;
	}
	clearTI(field) {
		var names = [];
		if (field == null) {
			var allSelected = document.querySelectorAll("table[data-table-tidata] tr[class*='checked']");
			if (allSelected.length == 0) {
				alert('Не выбраны получасовки для очистки причины');
				return;
			}

			document.querySelectorAll("tr[class*='checked']").forEach(function (el) {
				var container = el.querySelector("div[data-id*='_r']");
				if (container != null) {
					var name = container.getAttribute("data-id").replace("_r", "");
					names.push(name);
				}
			});

		}
		else {
			names.push(field);
		}
		var _this = this;
		if (_this.state != null) {
			names.forEach(function (name) {
				if (_this.state.diffjson[name]) {
					if (_this.state.diffjson[name].archDataDiff_ID > 0) {
						_this.state.diffjson[name].archDataDiffReasonCase_ID = 0;
						_this.state.diffjson[name].archDataDiffReason_ID = 0;
						_this.state.diffjson[name].archDataDiff_ID = _this.state.diffjson[name].archDataDiff_ID * (-1);
					}
					else if (_this.state.diffjson[name].archDataDiff_ID == 0)
						_this.state.diffjson[name] = null;
				}

				var col_r = document.querySelector("div[data-id='" + name + "_r']");
				col_r.classList.add("hide");
				var col_c = document.querySelector("div[data-id='" + name + "']");
				col_c.classList.add("hide");
				var del = document.querySelector("a[data-clearti='" + name + "']");
				del.classList.add("hide");

				if (col_r.parentElement.getAttribute("data-alldiff") !== null)
					col_r.parentElement.setAttribute("style", "background-color:#F08080");
				if (col_c.parentElement.getAttribute("data-alldiff") !== null)
					col_c.parentElement.setAttribute("style", "background-color:#F08080");


				document.querySelector("input[name='diffjsonti']").value = encodeURIComponent(JSON.stringify(_this.state.diffjson))
			});
		}
	}
};

Tango.registerComponent(archdatadiff_aupcompare_ti, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));